export default __webpack_public_path__ + "img/link.ef757ab00c8c30fe17f2ccaf784d03d8.svg";